import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { ILocationSuggestion } from "utils/geo";

type TInput = {
  term: string;
};

type TOutput = Array<ILocationSuggestion>;

export default class VillageWhisperApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri({ term }: TInput): string {
    return `/fe-api/address/village-whisper?term=${encodeURIComponent(term)}`;
  }

  mapResponseData(_status: number, data: any): TOutput {
    return data.map(
      (x: any): ILocationSuggestion => ({
        id: x.id,
        label: x.label,
        isAllowedForIn: x.isAllowedForIn,
      }),
    );
  }
}
